import { Injectable } from '@angular/core';
import { ScrollableModal } from '@egovsolutions/angular-scrollable-modal';
import { map } from 'rxjs/operators';
import { ConfirmDependentsDialogOptions, ConfirmDependentsRemovalComponent } from '../components/confirm-dependents-removal/confirm-dependents-removal.component';

@Injectable({ providedIn: 'any' })
export class ConfirmDependentsRemoval
{
    constructor
    (
        // Dependencies

        private readonly scrollableModal: ScrollableModal,
    )
    {}

    public launchConfirmationDialog(
        triggerItemName: string,
        additionalItemsNames: string[],
        alternativeText?: string
    )
    {
        const options: ConfirmDependentsDialogOptions = {
            triggerItemName,
            additionalItemsNames,
            alternativeText,
        };

        return this.scrollableModal.open(ConfirmDependentsRemovalComponent, { data: options }).afterClosed().pipe(
            map(v => !!v)
        );
    }
}
